<p mat-dialog-title style="font-size: 15px;">
  "{{ data.review }}"- Tell the customer your response to the review.
</p>
<div mat-dialog-content>
  <form
    [formGroup]="formContractorReviewResponse"
    autocomplete="nope"
    style="width: 100%;"
  >
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Respond</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        required
        placeholder=""
        id="response"
        name="response"
        formControlName="response"
        maxlength="2000"
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="10"
      ></textarea>
    </mat-form-field>
  </form>
</div>
<div
  mat-dialog-actions
  style="margin-top: 9px !important; float: right !important;"
>
  <button mat-button (click)="onClickCancel()">CANCEL</button>
  <button
    mat-flat-button
    (click)="onSave()"
    [mat-dialog-close]="data"
    color="primary"
    [disabled]="formContractorReviewResponse.pristine || formContractorReviewResponse.invalid"
  >
    SAVE
  </button>
</div>
